export default __webpack_public_path__ + "static/media/1016.dd474fec.png";